<template>
  <div class="oneGroupCConteiner">
    <el-checkbox ref="checkAll"
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      @change="handleCheckAllChange"
    >{{groupLabel}}<span class="indicator-text">:</span></el-checkbox>
    <!-- <span class="label">{{groupLabel}}:</span> -->
    <el-checkbox-group v-model="checkedItems" @change="handleCheckedItemsChange">
      <el-checkbox
        v-for="item in data"
        :label="item[keyProp]"
        :key="item[keyProp]"
        :disabled="!!item[disabledProp]"
      >{{item[labelProp]}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    groupLabel: {
      type: String,
      required: false,
      default: "全选"
    },
    data: {
      type: Array,
      required: true
    },
    keyProp: {
      type: String,
      required: true
    },
    labelProp: {
      type: String,
      required: true
    },
    disabledProp: {
      type: String,
      required: false,
      default: "disabled"
    },
    value: {
      type: Array,
      required: false,
      default: []
    }
  },
  data() {
    return {
      isIndeterminate: false,
      checkAll: false,
      checkedItems: []
    };
  },
  methods: {
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.changeCheckedItemsFollowCheckAll();
      this.$emit("input", this.checkedItems);
      this.$emit("change")
    },
    handleCheckedItemsChange(val) {
      this.changeCheckAllButtonState();      
      this.$emit("input", this.checkedItems);
      this.$emit("change")
    },
    changeCheckAllButtonState(){
      let arr = this.checkedItems.filter(a => {
        return this.uneditValueComputed.filter(b => {
          return a===b;
        }).length === 0; 
      });
      let checkedCount = arr.length;
      this.checkAll = checkedCount === this.enabledDataComputed.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.enabledDataComputed.length;
    },
    changeCheckedItemsFollowCheckAll(){
      let arr = [].concat(this.uneditValueComputed);
      if(this.checkAll){
        let keys = this.enabledDataComputed.map(item => {
          return item[this.keyProp];
        });
        arr = arr.concat(keys);
      }
      this.checkedItems = arr;
    },
    fitValueToCheckedItems(){
      let dataKeys = this.data.map(item => {
        return item[this.keyProp];
      });
      let val = this.value || [];
      let checked = dataKeys.filter(i => {
        return val.filter(j => {
          return i == j;
        }).length > 0;
      });
      this.checkedItems = checked;
      this.changeCheckAllButtonState();
    },
    //针对外层组件调用设计。全选/全不选
    selectAll(val){
      this.checkAll = !!val;
      this.isIndeterminate = false;
      this.changeCheckedItemsFollowCheckAll();
      this.$emit("input", this.checkedItems);
    },
    //针对外层组件调用设计。返回组件状态。
    getStatus(){
      return {
        isAllChecked: this.checkAll,
        isIndeterminate: this.isIndeterminate
      }
    }
  },
  computed: {
    //已选中条目中不可编辑的keys
    uneditValueComputed(){
      let val = this.checkedItems || [];
      let disabledDatas = this.data.filter(item => {return !!item[this.disabledProp]});
      let disabledKeys = disabledDatas.map(item => { return item[this.keyProp]});

      return val.filter(a => {
        return disabledKeys.filter(b => {
          return a === b
        }).length > 0;
      });      
    },
    //允许编辑的数据
    enabledDataComputed(){
      return this.data.filter(item => {
        return !item[this.disabledProp];
      });
    },
  },
  watch: {
    value(newVal){
      this.fitValueToCheckedItems();
    }
  },
  created(){
    this.fitValueToCheckedItems();
  }
};
</script>

<style lang="scss" scoped>
.oneGroupCConteiner{
  label{
    color: rgb(1, 27, 53);
  }
  &>.el-checkbox{
    margin-left: 10px;
    color: rgb(21, 8, 197);
    font-weight: bold;
  }
  &>.el-checkbox-group{
    margin-left: 20px;
  }
}
.indicator-text {
  margin-left: 2px;
}
</style>

